__turbopack_context__.v({
  "dialog": "dialog-module-scss-module__Hc50iG__dialog",
  "pointer": "dialog-module-scss-module__Hc50iG__pointer",
});
